<bs-digital-linear-result-model-header [title]="moduleName" [subtitle]="subtitle" [expand]="expanded" (expandToggled)="toggleExpand($event)" />

<ng-container *ngIf="expanded">
    <bs-digital-result-succeeded-pick-list>
        <bs-digital-result-succeeded-pick
            *ngFor="let pick of succeededSlip.picks; let last = last"
            [isLinear]="true"
            [ngClass]="{ 'last-child': last }"
            [pick]="pick"
            [boostedOdds]="succeededSlip.boostedOdds"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [isSummaryVisible]="false"
            [summary]="summaryViewModel" />

        <bs-digital-linear-result-bet-returns
            [stake]="succeededSlip.totalStake"
            [stakeMultiplier]="0"
            [possibleWinningsNet]="summaryViewModel.possibleWinnings?.value"
            [possibleWinningsGross]="summaryViewModel.possibleWinningsGross" />
    </bs-digital-result-succeeded-pick-list>

    <bs-digital-result-keep-placed
        *ngIf="resultState$ | async as resultState"
        [isLinear]="true"
        [keepPlaced]="keepPlaced(resultState)"
        [betType]="betType"
        (keepPlacedChanged)="onKeepPlacedChanged($event)" />

    <bs-digital-linear-result-links [succeededSlips]="[succeededSlip]" [inColumn]="inColumn" />
</ng-container>
